import { createContext, useContext } from 'react';

const WizardTitleSlotContext = createContext<HTMLElement | null>(null);

export const WizardTitleSlotProvider = WizardTitleSlotContext.Provider;

export const useWizardTitleSlot = () => useContext(WizardTitleSlotContext);
